import { Box, Text } from '@mantine/core';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

type Props = {
  content: string;
};

export function UserMessage({ content }: Props) {
  return (
    <Box
      px="md"
      py="sm"
      bg="gray.9"
      style={{
        borderRadius: 20,
        border: '1px solid var(--mantine-color-gray-7)',
      }}
    >
      <Text size="textSm" fw={FONT_WEIGHTS.bold} c="gray.1">
        {content}
      </Text>
    </Box>
  );
}
